/** Radix select value for “all sales reps” meetings filter */
export const ADMIN_REP_FILTER_ALL = "all";

/** Query param when super admin opens MAP on behalf of a rep */
export const ADMIN_VIEW_AS_EMAIL_PARAM = "view_as_email";

/** Query param when super admin views call history on behalf of a rep */
export const CALL_HISTORY_REP_EMAIL_PARAM = "repEmail";

export const CALL_HISTORY_ALL_REPS_LABEL = "All Reps";

export function isAdminRepFilterAll(emailId: string | null | undefined): boolean {
  return !emailId || emailId === ADMIN_REP_FILTER_ALL;
}

export function resolveCallHistoryViewEmail(
  repEmailFromUrl: string | undefined,
  clerkEmail: string | null | undefined,
  superAdmin: boolean,
): string | null {
  if (!superAdmin) {
    const own = clerkEmail?.trim();
    return own || null;
  }
  const fromUrl = repEmailFromUrl?.trim();
  if (fromUrl) return fromUrl;
  return null;
}

export function copyCallHistoryViewParams(
  from: URLSearchParams,
  to: URLSearchParams,
) {
  const repEmail = from.get(CALL_HISTORY_REP_EMAIL_PARAM)?.trim();
  if (repEmail) {
    to.set(CALL_HISTORY_REP_EMAIL_PARAM, repEmail);
  }
}
